import { handleDownloadError, triggerBrowserDownload } from '@helpers/jobLinkHelpers';
import { useAPI } from '@providers/useAPI';
import { useMutation } from '@tanstack/react-query';
import { RepositoriesService } from 'app/API';
import { useCallback } from 'react';

type TVariables = {
  attachmentId: string;
  fileName: string;
};

export const useDownloadRepositoryAttachment = () => {
  const { call } = useAPI();

  const { mutateAsync } = useMutation({
    mutationFn: ({ attachmentId }: TVariables) =>
      call(() =>
        RepositoriesService.downloadAttachment({ repositoryAttachmentId: attachmentId, disposition: 'attachment' }),
      ),
    onSuccess: (data, { fileName }) => {
      if (!data?.url) {
        handleDownloadError(new Error('Download URL missing'));
        return;
      }
      triggerBrowserDownload(data.url, fileName);
    },
    onError: handleDownloadError,
  });

  return useCallback(
    (attachmentId: string, fileName: string) =>
      mutateAsync({ attachmentId, fileName }).then(
        () => undefined,
        () => undefined,
      ),
    [mutateAsync],
  );
};
